import type { FormField } from '@cli-types/core-engine/schema.js'
import { sampleFormFieldValue } from './sample-form-field-value.js'
export function createFormInputObject(fields: FormField[]): Record<string, unknown> {
  return Object.fromEntries(
    fields
      .filter((field): field is FormField & { name: string } => Boolean(field.name))
      .map((field) => [field.name, sampleFormFieldValue(field)])
  )
}
